import { Text } from '@thanx/uikit/text'
import { SEGMENT_DETAILS } from 'components/SegmentDetails/constants'
import 'components/SegmentDetails/segmentDetails.scss'
import { buildTranslate } from 'locales'
import { Fields as TargetSegment } from 'models/TargetSegment'
import React from 'react'
import Tab from 'react-bootstrap-five/Tab'
import SegmentGroupsList from 'scenes/Segments/AISegmentBuilder/ThanxAISegmentVisualization/SegmentGroupsList'
import { SegmentGroup } from 'slices/aiConversations/segmentVisualizationTypes'

import 'scenes/Segments/AISegmentBuilder/ThanxAISegmentVisualization/ThanxAISegmentVisualization.scss'

const t = buildTranslate('segments.details')

interface SegmentRulesProps {
  segment: TargetSegment
  tabId?: string
}

const SegmentRules = ({ segment, tabId }: SegmentRulesProps) => {
  const visualizationData = segment.rule_visualization_data

  if (!visualizationData) {
    return (
      <Tab.Pane
        eventKey={SEGMENT_DETAILS.TAB_KEYS.SEGMENT_RULES}
        className="segment-details__tab-pane"
        role="tabpanel"
        id={
          tabId
            ? `${tabId}-${SEGMENT_DETAILS.TAB_KEYS.SEGMENT_RULES}-panel`
            : undefined
        }
        aria-labelledby={
          tabId
            ? `${tabId}-${SEGMENT_DETAILS.TAB_KEYS.SEGMENT_RULES}-tab`
            : undefined
        }
      >
        <div className="segment-details__section-header">
          <Text.BodyText3
            color="grey90"
            className="segment-details__section-title"
          >
            {t('segment_rules.title')}
          </Text.BodyText3>
        </div>
        <Text.BodyText4 color="grey70">
          {t('segment_rules.unavailable')}
        </Text.BodyText4>
      </Tab.Pane>
    )
  }

  let groups: SegmentGroup[] = []

  if (typeof visualizationData === 'string') {
    try {
      const parsedData = JSON.parse(visualizationData)
      groups = Array.isArray(parsedData) ? (parsedData as SegmentGroup[]) : []
    } catch {
      groups = []
    }
  } else if (Array.isArray(visualizationData)) {
    groups = visualizationData as SegmentGroup[]
  }

  return (
    <Tab.Pane
      eventKey={SEGMENT_DETAILS.TAB_KEYS.SEGMENT_RULES}
      className="segment-details__tab-pane"
      role="tabpanel"
      id={
        tabId
          ? `${tabId}-${SEGMENT_DETAILS.TAB_KEYS.SEGMENT_RULES}-panel`
          : undefined
      }
      aria-labelledby={
        tabId
          ? `${tabId}-${SEGMENT_DETAILS.TAB_KEYS.SEGMENT_RULES}-tab`
          : undefined
      }
    >
      <div className="segment-details__section-header">
        <Text.BodyText3
          color="grey90"
          className="segment-details__section-title"
        >
          {t('segment_rules.title')}
        </Text.BodyText3>
      </div>
      {groups.length === 0 ? (
        <Text.BodyText4 color="grey70">
          {t('segment_rules.no_rules')}
        </Text.BodyText4>
      ) : (
        <div className="thanx-ai-segment-visualization__filters">
          <SegmentGroupsList groups={groups} />
        </div>
      )}
    </Tab.Pane>
  )
}

export default SegmentRules
